'use strict';

if ( ! window.console) console = { log: function(){}, error: function(){} };

require('babel-polyfill');
require('./modules/utils');
// require('./modules/charts');
require('./modules/stickybits');
require('./modules/toggle');
